import { NgModule                         } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AdminDashboardModule       } from './admin-dashboard/admin-dashboard.module';
import { AdvisersModule             } from './advisers/advisers.module';
import { ApiModule                  } from './api/api.module';
import { ApiSettingsModule          } from './api-settings/api-settings.module';
import { AzureSsoModule             } from './azure-sso/azure-sso.module';
import { BillerModule               } from './biller/biller.module';
import { BookingsModule             } from './bookings/bookings.module';
import { BusinessIntelligenceModule } from './business-intelligence/business-intelligence.module';
import { CarfaxModule               } from './carfax/carfax.module';
import { ChargifyModule             } from './chargify/chargify.module';
import { CommunicationCenterModule  } from './communication-center/communication-center.module';
import { CompaniesModule            } from './companies/companies.module';
import { CompanyListsModule         } from './company-lists/company-lists.module';
import { CoreModule                 } from './core/core.module';
import { CountriesModule            } from './countries/countries.module';
import { CustomerPaymentsModule     } from './customer-payments/customer-payments.module';
import { CustomerPortalModule       } from './customer-portal/customer-portal.module';
import { CustomersModule            } from './customers/customers.module';
import { DealershipModule           } from './dealership/dealership.module';
import { DvlaLookupModule           } from './dvla-lookup/dvla-lookup.module';
import { EmailVerificationModule    } from './email-verification/email-verification.module';
import { FooterModule               } from './footer/footer.module';
import { FranchisesModule           } from './franchises/franchises.module';
import { GlobalSearchModule         } from './global-search/global-search.module';
import { GoogleSsoModule            } from './google-sso/google-sso.module';
import { GroupsRightsModule         } from './group-rights/group-rights.module';
import { GsfModule                  } from './gsf/gsf.module';
import { HaynesProModule            } from './haynes-pro/haynes-pro.module';
import { HeaderModule               } from './header/header.module';
import { ImportsModule              } from './imports/imports.module';
import { InspectionsModule          } from './inspections/inspections.module';
import { InternationalizationModule } from './internationalization/internationalization.module';
import { InvoicesModule             } from './invoices/invoices.module';
import { LoanCarScheduleModule      } from './loan-car-schedule/loan-car-schedule.module';
import { MailchimpModule            } from './mailchimp/mailchimp.module';
import { MechanicsModule            } from './mechanics/mechanics.module';
import { MessagesModule             } from './messages/messages.module';
import { MobileModule               } from './mobile/mobile.module';
import { ModalsModule               } from './modals/modals.module';
import { MyobModule                 } from './myob/myob.module';
import { OnlinePaymentsModule       } from './online-payments/online-payments.module';
import { PartstechModule            } from './partstech/partstech.module';
import { PodiumModule               } from './podium/podium.module';
import { PriceMatrixModule          } from './price-matrix/price-matrix.module';
import { ProductsModule             } from './products/products.module';
import { ProlinkModule              } from './prolink/prolink.module';
import { QuickbooksModule           } from './quickbooks/quickbooks.module';
import { QuotesModule               } from './quotes/quotes.module';
import { RecpatchaModule            } from './recaptcha/recaptcha.module';
import { RemindersModule            } from './reminders/reminders.module';
import { ReportsModule              } from './reports/reports.module';
import { RepcoModule                } from './repco/repco.module';
import { SecurityModule             } from './security/security.module';
import { SessionsModule             } from './sessions/sessions.module';
import { SharedModule               } from './shared/shared.module';
import { SidebarModule              } from './sidebar/sidebar.module';
import { StockTakeModule            } from './stock-take/stock-take.module';
import { StripeModule               } from './stripe/stripe.module';
import { SubscriptionsModule        } from './subscriptions/subscriptions.module';
import { TableModule                } from './table/table.module';
import { TaxGroupsModule            } from './tax-groups/tax-groups.module';
import { TemplatesModule            } from './templates/templates.module';
import { TillpaymentsModule         } from './tillpayments/tillpayments.module';
import { TireconnectModule          } from './tireconnect/tireconnect.module';
import { TransactionCenterModule    } from './transaction-center/transaction-center.module';
import { UKPostcodeModule           } from './uk-postcode/uk-postcode.module';
import { UnitsModule                } from './units/units.module';
import { UserflowModule             } from './userflow/userflow.module';
import { UsersModule                } from './users/users.module';
import { VehiclesModule             } from './vehicles/vehicles.module';
import { VehicleRegistrationsModule } from './vehicle-registrations/vehicle-registrations.module';
import { VehicleVisualsModule       } from './vehicle-visuals/vehicle-visuals.module';
import { VendorPaymentsModule       } from './vendor-payments/vendor-payments.module';
import { VendorsModule              } from './vendors/vendors.module';
import { VVGarageModule             } from './vv-garage/vv-garage.module';
import { WorkshopPayModule          } from './workshoppay/workshoppay.module';
import { WorkshopWebModule          } from './workshop-web/workshop-web.module';
import { WsApiModule                } from './ws-api/ws-api.module';
import { XeroModule                 } from './xero/xero.module';

import { DEFAULT_LANGUAGE } from './internationalization/internationalization.constants';
import { ImportLoader }     from './internationalization/translate.import-loader';


@NgModule({
  imports: [
    // Third party modules
    TranslateModule.forRoot({
      defaultLanguage: DEFAULT_LANGUAGE,
      loader         : {
        provide : TranslateLoader,
        useClass: ImportLoader
      }
    }),

    // Feature modules.
    AdminDashboardModule,
    AdvisersModule,
    ApiModule,
    ApiSettingsModule,
    AzureSsoModule,
    BillerModule,
    BookingsModule,
    BusinessIntelligenceModule,
    CarfaxModule,
    ChargifyModule,
    CommunicationCenterModule,
    CompaniesModule,
    CompanyListsModule,
    CoreModule,
    CountriesModule,
    CustomerPaymentsModule,
    CustomerPortalModule,
    CustomersModule,
    DealershipModule,
    DvlaLookupModule,
    EmailVerificationModule,
    FooterModule,
    FranchisesModule,
    GlobalSearchModule,
    GoogleSsoModule,
    GroupsRightsModule,
    GsfModule,
    HaynesProModule,
    HeaderModule,
    ImportsModule,
    InspectionsModule,
    InternationalizationModule,
    InvoicesModule,
    LoanCarScheduleModule,
    MailchimpModule,
    MechanicsModule,
    MessagesModule,
    MobileModule,
    ModalsModule,
    MyobModule,
    OnlinePaymentsModule,
    PartstechModule,
    PodiumModule,
    PriceMatrixModule,
    ProductsModule,
    ProlinkModule,
    QuickbooksModule,
    QuotesModule,
    RecpatchaModule,
    RemindersModule,
    ReportsModule,
    RepcoModule,
    SecurityModule,
    SessionsModule,
    SharedModule,
    SidebarModule,
    StockTakeModule,
    SecurityModule,
    StripeModule,
    SubscriptionsModule,
    TableModule,
    TaxGroupsModule,
    TemplatesModule,
    TillpaymentsModule,
    TireconnectModule,
    TransactionCenterModule,
    UKPostcodeModule,
    UnitsModule,
    UserflowModule,
    UsersModule,
    VehiclesModule,
    VehicleRegistrationsModule,
    VehicleVisualsModule,
    VendorPaymentsModule,
    VendorsModule,
    VVGarageModule,
    WorkshopPayModule,
    WorkshopWebModule,
    WsApiModule,
    XeroModule
  ]
})
export class AppLiteModule {}
